import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import {
  FcMedicalServiceProviderItemDto,
  FcModifyMedicalServiceProviderItemDto
} from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService, FormGroupArray } from '../../generic/fc-list-validation/fc-list-validation.service';

@Component({
  providers: [FcListValidationService, ApAlertService],
  selector: 'fc-medical-service-provider-list-modal',
  templateUrl: './fc-medical-service-provider-list-modal.component.html',
  styleUrls: ['./fc-medical-service-provider-list-modal.component.less']
})
export class FcMedicalServiceProviderListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-medical-service-provider';
  public demographicFormGroup: FormGroup = new FormGroup({});
  public directMessageFormGroup: FormGroup = new FormGroup({});
  public form: FormGroup = new FormGroup({
    demographic: this.demographicFormGroup,
    directMessage: this.directMessageFormGroup,
  });

  public listItem: FcMedicalServiceProviderItemDto = {
    Id: '',
    Corporation: {
      Id: '',
      ExternalID: '',
      Name: '',
      PrimaryContact: '',
      SecondaryContact: '',
      Address: {
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        CountyName: '',
        CountyCode: '',
      },
      Phone1: {
        PhoneNumber: '',
        PhoneType: '',
        PhoneTypeUid: '',
      },
      Phone2: {
        PhoneNumber: '',
        PhoneType: '',
        PhoneTypeUid: '',
      },
      Phone3: {
        PhoneNumber: '',
        PhoneType: '',
        PhoneTypeUid: '',
      },
      Phone4: {
        PhoneNumber: '',
        PhoneType: '',
        PhoneTypeUid: '',
      },
      Email1: '',
      Email2: '',
      Inactive: false,
    },
    CorporationUid: '',
    ExternalID: '',
    Inactive: false,
    MedicalServicesTypeUid: '',
    MedicalServicesType: {
      ExternalID: '',
      Inactive: false,
      MedicalServicesTypeUid: '',
      Name: '',
      Notes: '',
      UserDefined: true,
    },
    Notes: ''
  };

  public override ngOnInit() {
    super.ngOnInit();

    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 100,
      },
      Notes: {
        MaxLength: 65535,
      },
      PrimaryContact: {
        MaxLength: 50,
      },
      SecondaryContact: {
        MaxLength: 50,
      },
    });
  }

  public setForm(): void {
    this.validateForm();
  }

  public getFormValidationErrors(formGroup: FormGroupArray): number {
    return FcListValidationService.getFormValidationErrors(formGroup, this.isSubmitted);
  }

  public override save(): void {
    this.isSubmitted = true;
    const values = this.form.getRawValue();

    const demographics = values.demographic;
    const modifyItemDto: FcModifyMedicalServiceProviderItemDto = {
      ...(demographics.corporationUid && {Id: demographics.corporationUid}),
      Corporation: {
        ...(demographics.corporationUid && {Id: demographics.corporationUid}),
        Name: demographics.name ?? '',
        Address: {
          Address1: demographics.address?.addressOne,
          Address2: demographics.address?.addressTwo,
          City: demographics.address?.city,
          State: demographics.address?.state,
          Zip: demographics.address?.zip,
          ZipUid: this.parseFindControlValue(demographics.address?.zipControl ?? ''),
          Country: demographics.address?.country,
          CountyName: demographics.address?.countyName,
          CountyCode: demographics.address?.countyCode,
        },
        Email1: demographics?.emailOne,
        Email2: demographics?.emailTwo,
        PrimaryContact: demographics?.primaryContact,
        SecondaryContact: demographics?.secondaryContact,
      },
      ...(demographics?.medicalServiceType &&
        {MedicalServicesTypeUid: this.parseFindControlValue(demographics?.medicalServiceType ?? '')}),
      Inactive: demographics.inactive,
      Notes: demographics?.notes ?? '',
      ExternalID: demographics.externalId
    };

    if (
      demographics.phoneOne.phoneNumber &&
      demographics.phoneOne.phoneType &&
      demographics.phoneOne.phoneTypeUid &&
      modifyItemDto.Corporation != null
    ) {
      modifyItemDto.Corporation.Phone1 = {
        PhoneNumber: demographics.phoneOne.phoneNumber,
        PhoneType: demographics.phoneOne.phoneType,
        PhoneTypeUid: this.parseFindControlValue(demographics.phoneOne.phoneTypeUid),
      };
    }
    if (
      demographics.phoneTwo.phoneNumber &&
      demographics.phoneTwo.phoneType &&
      demographics.phoneTwo.phoneTypeUid &&
      modifyItemDto.Corporation != null
    ) {
      modifyItemDto.Corporation.Phone2 = {
        PhoneNumber: demographics.phoneTwo.phoneNumber,
        PhoneType: demographics.phoneTwo.phoneType,
        PhoneTypeUid: this.parseFindControlValue(demographics.phoneTwo.phoneTypeUid),
      };
    }
    if (
      demographics.phoneThree.phoneNumber &&
      demographics.phoneThree.phoneType &&
      demographics.phoneThree.phoneTypeUid &&
      modifyItemDto.Corporation != null
    ) {
      modifyItemDto.Corporation.Phone3 = {
        PhoneNumber: demographics.phoneThree.phoneNumber,
        PhoneType: demographics.phoneThree.phoneType,
        PhoneTypeUid: this.parseFindControlValue(demographics.phoneThree.phoneTypeUid),
      };
    }
    if (
      demographics.phoneFour.phoneNumber &&
      demographics.phoneFour.phoneType &&
      demographics.phoneFour.phoneTypeUid &&
      modifyItemDto.Corporation != null
    ) {
      modifyItemDto.Corporation.Phone4 = {
        PhoneNumber: demographics.phoneFour.phoneNumber,
        PhoneType: demographics.phoneFour.phoneType,
        PhoneTypeUid: this.parseFindControlValue(demographics.phoneFour.phoneTypeUid),
      };
    }

    super.save<FcModifyMedicalServiceProviderItemDto>(modifyItemDto);
  }
}
